import * as React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { MessageBlock, MessageTypes } from '@amzn/dvui/dist/Block'
import { Text } from '@amzn/dvui/dist/Text'
import { TextLocalizer, StringId } from '../localizer/localizer'
import { IDetailPageState } from '../../reducers'
import { clearBanner, createBanner } from '../../actions/banner'
import { buildDvString, DVStringAttrs } from '../../utils/stringUtils'
import { RefmarkerTemplate } from '@amzn/dv-web-node-reftags'
import * as st from './uiBanner.module.scss'
import { DpWidgetContext } from '../../utils/dpWidgetContext'

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

const TRANSITION_MS = 300

// TODO(AVWebDP-921): Extract the WatchParty-specific logic from this component
const wpLearnMoreDVAttrs = (template: RefmarkerTemplate) => {
  return {
    learnMore: {
      href: `/watchparty/ref=${template}`
    }
  }
}

interface IBannerMessageMap {
  [key: string]: {type: MessageTypes, heading: StringId, body: StringId, dvStringAttrs?: DVStringAttrs}
}
const bannerMessageMap: IBannerMessageMap = {
  WP_ERROR: {type: MessageTypes.warning, heading: 'DV_DP_WP_ERROR_HEADING', body: 'DV_DP_WP_ERROR'},
  WP_END: {type: MessageTypes.info, heading: 'DV_DP_WP_END_HEADING', body: 'DV_DP_WP_END'},
  WP_STREAM_ENDED: {type: MessageTypes.info, heading: 'DV_DP_WP_END_HEADING', body: 'DV_DP_WP_STREAM_ENDED'},
  WP_CREATE_INELIGIBLE: {type: MessageTypes.warning, heading: 'DV_DP_WP_CREATE_INELIGIBLE_HEADING', body: 'DV_DP_WP_CREATE_INELIGIBLE', dvStringAttrs: wpLearnMoreDVAttrs('atv_dp_wp_cr_in_learn')},
  WP_JOIN_INELIGIBLE: {type: MessageTypes.warning, heading: 'DV_DP_WP_JOIN_INELIGIBLE_HEADING', body: 'DV_DP_WP_JOIN_INELIGIBLE', dvStringAttrs: wpLearnMoreDVAttrs('atv_dp_wp_jn_in_learn')},
  WP_GEO_RESTRICTION: {type: MessageTypes.warning, heading: 'DV_DP_WP_GEO_RESTRICTION_HEADING', body: 'DV_DP_WP_GEO_RESTRICTION'},
  WP_UNSUPPORTED_BROWSER: {type: MessageTypes.warning, heading: 'DV_DP_WP_UNSUPPORTED_BROWSER_HEADING', body: 'DV_DP_WP_UNSUPPORTED_BROWSER', dvStringAttrs: wpLearnMoreDVAttrs('atv_dp_wp_ub_learn')},
}

export const UiBannerComponent = ({queryParameters, createBanner, banner, clearBanner}: Props) => {
  const { getString } = React.useContext(DpWidgetContext)
  React.useEffect(() => {

    const messageCode = queryParameters.bannerMsg

    if (messageCode) {
      const bannerPayload = bannerMessageMap[messageCode.join('').toUpperCase()]
      bannerPayload && createBanner(bannerPayload.type, getString(bannerPayload.heading), getString(bannerPayload.body), bannerPayload.dvStringAttrs)
    }
  }, [createBanner, getString, queryParameters.bannerMsg])

  if (!banner) {
    return null
  }
  const { stringId, string, type, heading, dvStringAttrs } = banner
  const attrs = dvStringAttrs || {}
  const dvString = buildDvString(string, attrs)
  return (
    <MessageBlock className={st.bannerMessage} heading={heading || ''} type={type} dismissable onDismiss={clearBanner}>
      {stringId && <TextLocalizer stringID={stringId} dvStringAttrs={attrs}/>}
      {string && <Text string={dvString} />}
    </MessageBlock>
  )
}

const mapStateToProps = (state: IDetailPageState) => ({
  banner: state.banner.ui,
  queryParameters: state.requestContext && state.requestContext.queryParameters
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  clearBanner: () => setTimeout(() => dispatch(clearBanner()), TRANSITION_MS),
  createBanner: (messageType: MessageTypes, heading: string, string: string, dvStringAttrs?: DVStringAttrs) =>
    dispatch(createBanner({
      type: messageType,
      string,
      heading,
      ...(dvStringAttrs ? { dvStringAttrs } : {})
    }))
})

export const UiBanner = connect(mapStateToProps,mapDispatchToProps)(UiBannerComponent)
